// extracted by mini-css-extract-plugin
export default {"form":"CreateForm_form__cpRWE","inputField":"CreateForm_inputField__J1pg8","createButton":"CreateForm_createButton__yRfOC","checkboxes":"CreateForm_checkboxes__bdabh"};